import { RightsizingSettingsV1ValidationSchema } from '../../../../_validations/rightsizing-settings-v1-validation.schema';
import { WorkloadVpaFormSettings } from '../../_constants';

export const settingsRowError: Record<
  WorkloadVpaFormSettings,
  (prop: { errors: RightsizingSettingsV1ValidationSchema }) => boolean
> = {
  optimizedResources: ({ errors }) =>
    !!errors?.verticalRightsizing?.policy?.optimizedResources,
  excludedContainers: ({ errors }) =>
    !!errors?.verticalRightsizing?.policy?.excludedContainers,
  customMetrics: ({ errors }) =>
    !!errors?.verticalRightsizing?.policy?.customMetrics,
  autoscaler: ({ errors }) =>
    !!errors?.verticalRightsizing?.policy?.applyType ||
    !!errors?.verticalRightsizing?.policy?.antiAffinity ||
    !!errors?.verticalRightsizing?.policy?.optimizationThreshold ||
    !!errors?.verticalRightsizing?.policy?.rolloutBehavior,
  overhead: ({ errors }) => !!errors?.verticalRightsizing?.policy?.overhead,
  memoryGrowthDetection: ({ errors }) =>
    !!errors?.verticalRightsizing?.policy?.memoryGrowthDetection,
  stallDetection: ({ errors }) =>
    !!errors?.verticalRightsizing?.policy?.stallDetection,
  recommendationPercentile: ({ errors }) =>
    !!errors?.verticalRightsizing?.policy?.recommendationPercentile,
  workloadResourceLimits: ({ errors }) =>
    !!errors?.verticalRightsizing?.policy?.resourceLimits,
  workloadConstraints: ({ errors }) =>
    !!errors?.verticalRightsizing?.policy?.workloadConstraints,
  lookbackPeriod: ({ errors }) =>
    !!errors?.verticalRightsizing?.policy?.lookbackPeriod,
  startupMetrics: ({ errors }) =>
    !!errors?.verticalRightsizing?.policy?.startupMetrics,
  hpaConverter: ({ errors }) =>
    !!errors?.verticalRightsizing?.policy?.hpaConverter,
  predictiveScaling: ({ errors }) =>
    !!errors?.verticalRightsizing?.policy?.predictiveScaling,
};
